import { ControlType } from '../../../Enums'

export const availableControls = [ControlType.Textbox, ControlType.CheckboxList, ControlType.Dropdown]
